import { Button, Checkbox, FormControlLabel } from '@material-ui/core';
import { useEffect, useMemo, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { keys, _renderBank } from '.';
import { ActionHeader, FaqLink } from '..';
import en from '../../../../lang/en-us';
import { TableColumn, TableWithCollapse } from '../../../../lib/DataTable';
import { useTableWithCollapse } from '../../../../lib/DataTable/customHooks';
import { fetchInvestorDetails, sendPhoneOTP } from '../../../../redux-store/actions/nct';
import { panSeedCheck } from '../../../../redux-store/actions/newPurchase';
import { RootStateType } from '../../../../redux-store/reducers';
import { OTP_ACTIONS, CONSOLIDATION_FOLIOS } from '../../../../utils/constants';
// import NoFoliosFound from '../NoFoliosFound';
import { ConsolidateTableRowType } from './types';
const { dashboard } = en;

export const Columns: TableColumn[] = [
    {
        field: 'id',
        headerName: 'Folio',
    },
    {
        field: 'investorName',
        headerName: 'PRIMARY HOLDER',
        width: 200,
    },
    {
        field: 'investorPan',
        headerName: 'PAN',
        width: 100,
    },
    {
        field: 'modeOfHolding',
        headerName: 'MODE OF HOLDING',
        width: 100,
    },
    {
        field: 'bank',
        headerName: 'BANK NAME',
        valueGetter: ({ row }) => row?.bank[0]?.name,
        width: 150,
    },
    {
        field: '',
        headerName: '',
        renderCell: _renderBank,
        width: 20,
    },
];

export function ConsolidationSourceFolios(props: any) {
    const { selectedRows, setSelectedRows, resetTable, ...filters } = useTableWithCollapse<
        ConsolidateTableRowType[]
    >({
        initialSelectionModal: [],
    });
    const [isChecked, setChecked] = useState<boolean>(false);
    const [show, setShow] = useState<boolean>(false);

    const { matched = [], unMatched = [], amcType, folio, amc } = props.location.state || {};

    useEffect(() => {
        if (!amcType || !folio) {
            props.history.push('/');
        }
    }, []);

    const handleSubmit = async () => {
        setShow(false);
        const { pan, pekrn, mobile } = props;
        try {
            let res = await props.sendPhoneOTP({
                mobile,
                pan,
                pekrn,
                action: OTP_ACTIONS.consolidationFolios,
            });
            let transformedData: any = [];
            selectedRows.forEach((row: ConsolidateTableRowType) => {
                transformedData.push({
                    amc,
                    targetFolio: folio,
                    sourceFolio: row.folio,
                });
            });
            props.history.replace('consolidation-folios-otp', {
                mobile,
                pan,
                data: transformedData,
                ...(res || {}).body,
            });
        } catch (err: any) {
            alert(err.message);
        }
    };

    const _renderCollapse = ({ row }: { row: ConsolidateTableRowType }) => {
        const { nominees = [], bank } = row;
        const rowKeydData: any = {
            firstNominee: nominees[0]?.name,
            secindNominee: nominees[1] ? nominees[1]?.name : '',
            thirdNominee: nominees[2] ? nominees[2]?.name : '',
            ifsc: bank[0]?.ifsc,
            accountNo: bank[0]?.accountNo,
            ...row,
        };
        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'space-between',
                    flexWrap: 'wrap',
                    flexDirection: 'row',
                    width: '100%',
                }}
            >
                {keys.map(({ label, key }: any, index: number) => (
                    <div
                        key={index}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '25%',
                            marginBottom: 15,
                            paddingRight: 15,
                        }}
                    >
                        <label>{label}</label>
                        <label>{rowKeydData[key] || ''}</label>
                    </div>
                ))}
            </div>
        );
    };

    const TableBody = useMemo(() => {
        return (
            <TableWithCollapse
                rows={[...matched, ...unMatched]}
                columns={Columns}
                setSelectedRows={setSelectedRows}
                selectedRows={selectedRows}
                toolTipTextGetter={({ row }) =>
                    row.isDisabled ? dashboard.noteModals.consolidation.info : ''
                }
                renderCollapse={_renderCollapse}
                checkBoxEnabled
                {...filters}
                toolTipEnabled
            />
        );
    }, [matched, unMatched, Columns, selectedRows, filters]);
    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.ConsolidationFolios.ConsolidationFoliosHeading} />
            <div className="curved-bg-content curved-bg-table-outer consolidated-folios-outer">
                <div className="curved-bg-content-table">
                    <div className="consolidated-source-top">
                        <h5>
                            {dashboard.ConsolidationFolios.ConsolidationFoliosInfo}
                            <span>{amcType}</span>
                        </h5>
                        <h5>
                            {dashboard.ConsolidationFolios.targetFolio}
                            <span>{folio}</span>
                        </h5>
                    </div>
                    <h5>{dashboard.ConsolidationFolios.sourceFolio}</h5>
                    <div className="curved-table-content">
                        {/* <NoFoliosFound
                            extraClass="consolidation-error"
                            icon="error-red"
                            info={dashboard.ConsolidationFolios.EmptyFolioInfo}
                        /> */}
                        {TableBody}
                    </div>
                </div>
                <FaqLink section={CONSOLIDATION_FOLIOS} history={props.history} />
                <div className="curved-bg-content-inner-bottom fatca-bottom-content">
                    <div className="consolidation-terms">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="consolidation-terms"
                                    checked={isChecked}
                                    onChange={() => setChecked(!isChecked)}
                                />
                            }
                            label={dashboard.ConsolidationFolios.terms}
                        />
                    </div>
                    <Button
                        onClick={handleSubmit}
                        disabled={!selectedRows.length || !isChecked}
                        className="customBtn"
                    >
                        {dashboard.ConsolidationFolios.buttonText}
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    fetchInvestorDetails,
    sendPhoneOTP,
})(ConsolidationSourceFolios);
